import PageHeader from '@/components/page-header';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { humanize } from '@/lib/format';
import { console_login_path } from '@/rails/routes';
import { Form } from '@inertiajs/react';

interface Props {
  user: { name: string; emailAddress: string };
  companyName: string;
  role: string | null;
}

export default function Show({ user, companyName, role }: Props) {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Your login"
        description={`${user.emailAddress} · ${role ? humanize(role) : 'Member'} of ${companyName}`}
      />

      <Card>
        <CardHeader>
          <CardTitle>Name</CardTitle>
          <CardDescription>How you appear to the people you work with.</CardDescription>
        </CardHeader>
        <CardContent>
          <Form method="patch" action={console_login_path()} className="max-w-md space-y-4">
            {({ processing }) => (
              <>
                <div className="space-y-1.5">
                  <Label htmlFor="login-name">Name</Label>
                  <Input id="login-name" name="user.name" defaultValue={user.name} required />
                </div>
                <Button type="submit" disabled={processing}>
                  Save name
                </Button>
              </>
            )}
          </Form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Password</CardTitle>
          <CardDescription>
            12 characters or more. Changing it signs out your other devices.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form
            method="patch"
            action={console_login_path()}
            resetOnSuccess
            className="max-w-md space-y-4"
          >
            {({ processing }) => (
              <>
                <div className="space-y-1.5">
                  <Label htmlFor="login-current-password">Current password</Label>
                  <Input
                    id="login-current-password"
                    name="user.current_password"
                    type="password"
                    autoComplete="current-password"
                    required
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="login-new-password">New password</Label>
                  <Input
                    id="login-new-password"
                    name="user.password"
                    type="password"
                    autoComplete="new-password"
                    minLength={12}
                    required
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="login-confirm-password">New password again</Label>
                  <Input
                    id="login-confirm-password"
                    name="user.password_confirmation"
                    type="password"
                    autoComplete="new-password"
                    minLength={12}
                    required
                  />
                </div>
                <Button type="submit" disabled={processing}>
                  Change password
                </Button>
              </>
            )}
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}
